var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 38,
    viewBox: "0 0 13 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54663 1.17032H9.1261L11.6528 18.8548L9.1261 36.5391H1.54663L4.07331 18.8548L1.54663 1.17032Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13036 0H10.0624L13 18.5888V19.4111L10.0624 38H0L3.00263 19.0001L0 0H1.13036ZM8.766 3.05086H2.26066L4.71615 18.5888V19.4111L2.26066 34.949H8.766L11.2865 19.0001L8.766 3.05086Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.08aac0e9c93cdf86e08183cad2a44a92.svg";
export { ForwardRef as ReactComponent };